import { textStyles } from "../foundations/typography"

export const FormLabel = {
  baseStyle: {
    ...textStyles.label,
  },
}
